exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TYPOGRAPHY */\n.mark, mark {\n    background: #f2a654;\n    color: #ffffff;\n}\n\n.blockquote {\n    background: #f2f4f8;\n    padding: 30px;\n    border-left: 3px solid #d2d9e5;\n    font-size: 1.07rem;\n}\n\n.blockquote-reverse {\n    text-align: right;\n    border-left: none;\n    border-right: 3px solid #d2d9e5;\n}\n\n.blockquote-footer {\n    margin-top: 1.42rem;\n    color: #b8beca;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/node_modules/postcss-loader?{"ident":"postcss"}!/Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/vendors/bootstrap/css/typography.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/modules/vendors/bootstrap/css/typography.css
// module chunks = styles